import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'

/**
 * 香研社 Perfume Lab v1.2
 * QueryClient 全局配置 - 桌面应用专用优化
 */

// 桌面专用构建(VITE_DESKTOP=1):只挂核心页面、导航裁剪、启动免登录。
// 线上默认构建该值为 false,以上行为全部不生效。
const DESKTOP = import.meta.env.VITE_DESKTOP === '1'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,      // 全局默认 2 分钟内不重新请求
      gcTime: 30 * 60 * 1000,         // 30 分钟后垃圾回收
      retry: 1,                       // 失败只重试 1 次
      refetchOnWindowFocus: false,    // 桌面应用不需要焦点刷新
      refetchOnReconnect: false,      // 网络恢复不自动刷新（本地服务）
    },
  },
})

// 桌面端免登录:启动时若无 token,向内置后端要一个游客会话。
// 仅在桌面构建生效;失败不阻塞渲染(浏览不受影响,保存配方时才需要 token)。
// 游客固定 id 与后端 request-user.ts 的 APP_GUEST_USER_ID 一致;Formulas 页靠
// perfume_user_id 拉"我的配方",缺了会返回空列表(后端 AND 1=0)。
const DESKTOP_GUEST_USER_ID = '00000000-0000-0000-0000-000000000001'

async function ensureDesktopSession() {
  if (!DESKTOP) return
  // 旧构建可能已写入 token 但漏了 perfume_user_id,兜底补齐
  if (localStorage.getItem('token')) {
    if (!localStorage.getItem('perfume_user_id')) {
      localStorage.setItem('perfume_user_id', DESKTOP_GUEST_USER_ID)
    }
    return
  }
  try {
    const response = await fetch('/api/v1/auth/desktop', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    })
    const json = await response.json()
    if (json.success && json.data?.token) {
      localStorage.setItem('token', json.data.token)
      localStorage.setItem('perfume_user_id', json.data.user?.id || DESKTOP_GUEST_USER_ID)
    }
  } catch {
    // 后端暂未就绪:保持无 token,浏览仍可用
  }
}

ensureDesktopSession().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/perfume">
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  )
})
